export default "__VITE_ASSET__8DCR7mk6__"